import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, MainContainer, SelectDropDown } from '@wot/components';
import { TextInput } from '@wot/shared';
import BottomSheet from '../../components/Bottomsheet';
import { MdClose } from 'react-icons/md';
import { SUCCESS } from '../../assets/images';
import { toast } from 'react-toastify';
import { useAppSelector } from '../../hooks/useRedux';
import enquiryApi from '../../api/enquiry';

const CONTACT_SUBJECTS = ['Account Support', 'General Support', 'Payment Support'];

export default function Contact() {
  const { profile: userData } = useAppSelector((state) => state.profileSlice);
  const [subject, setSubject] = useState<string>('');
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [onSuccess, setOnSuccess] = useState(false);
  const [enquiryId, setEnquiryId] = useState();

  const onSubmit = (data: any) => {
    if (!subject) {
      toast.error('Please select a subject');
      return;
    }
    setLoading(true);
    let enquiry = {};
    if (userData?._id) {
      enquiry = {
        subject: subject,
        tutorId: userData._id,
        name: userData.personal.data.name,
        email: userData.personal.data.email,
        profilePic: userData.personal.data.profilePic,
        description: data.description,
        type: 'support'
      };
    } else {
      enquiry = {
        subject: subject,
        name: data.name,
        email: data.email,
        description: data.description,
        type: 'general'
      };
    }
    enquiryApi
      .add(enquiry)
      .then((res) => {
        if (res.data) {
          setEnquiryId(res.data.insertedId);
        }
        setLoading(false);
        setOnSuccess(true);
        reset();
        setSubject('');
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <MainContainer >
      <div className="container h-full bg-white px-7 md:px-10 py-7 flex flex-col rounded-xl">
        <h1 className="text-xl font-bold pb-4 border-b-2">Submit a Request</h1>

        <form onSubmit={handleSubmit(onSubmit)} className="w-full flex flex-col gap-7 my-4">
          <div className="w-full flex flex-col gap-2">
            <p className="text-sm font-medium">Select the relevant subject?</p>
            <SelectDropDown
              value={subject}
              onChange={(value) => setSubject(value)}
              options={CONTACT_SUBJECTS}
              placeholder="Select a subject"
            />
          </div>
          {!userData?._id ? (
            <div className="w-full flex flex-col md:flex-row items-center gap-4">
              <div className="w-full flex flex-col gap-2">
                <TextInput
                  label="Full Name"
                  register={register}
                  type="text"
                  name="name"
                  placeholder="Enter name"
                  required={'This field is required'}
                  errors={errors}
                />
              </div>

              <div className="w-full flex flex-col gap-2">
                <TextInput
                  label="Email ID"
                  register={register}
                  type="text"
                  name="email"
                  pattern={{
                    value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: 'Please enter a valid email address'
                  }}
                  placeholder="Enter Email"
                  required={'This field is required'}
                  errors={errors}
                />
              </div>
            </div>
          ) : null}

          <div className="w-full flex flex-col gap-2">
            <label htmlFor="email" className="text-sm font-medium">
              Description
            </label>
            <textarea
              rows={10}
              maxLength={200}
              placeholder="Message(maximum 200 words)"
              className={`w-full h-full resize-none outline-none focus:outline-1 disabled:outline-gray-300 focus:outline-blue-300 bg-neutralBlue2 px-4 py-2 rounded-md cursor-text
              `}
              {...register('description', { required: { value: true, message: 'This field is required' } })}
            ></textarea>
          </div>
          <div className="w-full max-w-[164px] mx-auto">
            <Button block loading={loading} type="primary" text="Submit" />
          </div>
        </form>
        {onSuccess && (
          <BottomSheet height={50}>
            <div className="w-full h-full mt-4 p-5 flex flex-col gap-7 items-center">
              <div className="w-full flex justify-between">
                <MdClose className="right-0 text-2xl cursor-pointer ml-auto" onClick={() => setOnSuccess(false)} />
              </div>
              <div className="w-full mx-auto flex items-center justify-center">
                <img src={SUCCESS} className="w-14 h-14 object-cover" />
              </div>

              <div className="flex flex-col gap-2 items-center justify-center">
                <h1 className="text-xl font-semibold">Successfully Submitted</h1>
                <p className="text-sm">Enquiry #{enquiryId}</p>
              </div>

              <p className="text-sm">
                Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Do Eiusmod Tempor Incididunt Ut Labore Et
                Dolore Magna Aliqua. Ut Enim Ad Minim Veniam,{' '}
              </p>
              <div className="w-full max-w-[164px] mx-auto">
                <Button onClick={() => setOnSuccess(false)} block text="Done" />
              </div>
            </div>
          </BottomSheet>
        )}
      </div>
    </MainContainer>
  );
}
